import { rtkApi } from "../rtkApi";
import { Referral } from "../../types/referral";

export const referralApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getReferrals: build.query<Referral[], void>({
      query: () => ({
        url: "/referrals",
        method: "GET",
      }),
      transformResponse: (resp: { referrals: Referral[] }) => resp.referrals,
      providesTags: ["Referrals"],
    }),
    updateReferral: build.mutation<void, { id: number; rewarded: boolean }>({
      query: ({ id, rewarded }) => ({
        url: `/referrals/${id}`,
        method: "POST",
        body: { rewarded },
      }),
      async onQueryStarted({ id, rewarded }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          referralApi.util.updateQueryData("getReferrals", undefined, (draft) => {
            const referral = draft.find((r) => r.id === id);
            if (referral) {
              referral.rewarded = rewarded;
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: ["Referrals"],
    }),
  }),
  overrideExisting: true,
});

export const { useGetReferralsQuery, useUpdateReferralMutation } = referralApi;
